import React, { useState } from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import AIConnectionSetupModal from './AIConnectionSetupModal';
import CreateProductModal from './knowledge/CreateProductModal';

/**
 * NotificationModals - Centralized modal renderer for notifications
 *
 * Listens to activeModal from NotificationContext and renders
 * the appropriate modal based on notification type.
 */
export default function NotificationModals() {
  const { activeModal, closeModal, markAsActioned, markAsDismissed } = useNotifications();

  if (!activeModal) {
    return null;
  }

  // Handle modal close - mark as dismissed
  const handleClose = async () => {
    console.log('[NotificationModals] Closing modal, marking as dismissed');
    if (activeModal.id && activeModal.is_persistent) {
      await markAsDismissed(activeModal.id);
    } else {
      closeModal();
    }
  };

  // Handle successful action - mark as actioned
  const handleSuccess = async () => {
    console.log('[NotificationModals] Action successful, marking as actioned');
    if (activeModal.id && activeModal.is_persistent) {
      await markAsActioned(activeModal.id);
    } else {
      closeModal();
    }
  };

  // Render appropriate modal based on notification type
  switch (activeModal.type) {
    case 'ai_connection_missing':
      return (
        <AIConnectionSetupModal
          isOpen={true}
          onClose={handleClose}
          onSuccess={handleSuccess}
        />
      );

    case 'no_products':
      return (
        <CreateProductModal
          isOpen={true}
          onClose={handleClose}
          onProductCreated={handleSuccess}
          triggeredFrom="notification"
        />
      );

    // Add more notification types here as needed
    // case 'permission_required':
    //   return <PermissionRequiredModal ... />;
    // case 'storage_quota':
    //   return <StorageQuotaModal ... />;

    default:
      console.warn('[NotificationModals] Unknown notification type:', activeModal.type);
      return null;
  }
}
